<template>
  <div style="padding-bottom: 50px">
    <el-card>
      <div slot="header" class="card-title">{{ $t('storage::in-stock::入库单信息') }}</div>
      <el-form class="stock-form" :model="order" label-width="120px" ref="order" :label-position="'top'" :rules="rules">
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::in_type')" prop="stockType">
              <el-select
                :popperAppendToBody="false"
                v-model="order.stockType"
                clearable
                :placeholder="$t('storage::in-stock::please_select')"
                class="input-item"
              >
                <el-option
                  v-for="item in menuList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::supplier')" prop="supplierId">
              <el-select
                v-model="order.supplierId"
                :popperAppendToBody="false"
                clearable
                @change="changeSupplier"
                :placeholder="$t('storage::in-stock::please_select')"
                class="input-item"
              >
                <el-option
                  v-for="item in supplierList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::relate_num')" prop="sourceNo">
              <el-input
                :placeholder="$t('storage::in-stock::input_holder')"
                v-model.trim="order.sourceNo"
                class="input-with-select input-item"
              >
                <el-select
                  :popperAppendToBody="false"
                  v-model="order.sourceNoType"
                  slot="prepend"
                  style="color: #010517"
                >
                  <el-option :label="$t('storage::in-stock::purchase_order')" :value="1"></el-option>
                  <el-option :label="$t('storage::in-stock::order')" :value="2"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::fullfillment_num')" prop="fulfillmentNo">
              <el-input v-model.trim="order.fulfillmentNo" class="input-item"></el-input>
            </el-form-item>
          </el-col>
          <template v-if="$route.params.id">
            <el-col ::span="8">
              <el-form-item :label="$t('storage::in-stock::creator')">
                {{ order.applicantditorName || '--' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('storage::in-stock::table_create_time')">
                {{ order.createTime || '--' }}
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="8" v-else>
            <el-form-item :label="$t('storage::in-stock::instock_date')" prop="operTime">
              <el-date-picker
                :appendToBody="false"
                v-model="order.operTime"
                :pickerOptions="pickerOptions"
                type="date"
                :placeholder="$t('storage::in-stock::select_date')"
                class="input-item"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::third_bill_num')" prop="thirdPartyNo">
              <el-input v-model.trim="order.thirdPartyNo" class="input-item"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('storage::in-stock::remark')">
              <el-input v-model="order.remark" rows="4" type="textarea" maxlength="50" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <div slot="header" class="card-title">{{ $t('storage::in-stock::入库商品信息') }}</div>
      <div style="display: flex; justify-content: space-between" class="mb-16">
        <div style="display: flex; align-items: center">
          <el-button type="primary" @click="showAddSku" icon="el-icon-plus" :disabled="!order.supplierId">
            {{ $t('storage::in-stock::add_sku') }}
          </el-button>
          <el-button type="primary" v-show="order.supplierId" @click="isImportSku = true">
            {{ $t('storage::in-stock::import') }}
          </el-button>
          <span style="margin-left: 10px; color: #d9001b" v-show="!order.supplierId">
            {{ $t('storage::in-stock::supplier_select_holder') }}
          </span>
        </div>
        <div>
          <span>SKU</span>
          <el-input v-model="searchValue" style="width: 200px; margin-left: 16px">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <el-form :model="order" ref="request" class="demo-ruleForm">
        <z-table
          :columns="tableColumns"
          :data="detailList"
          :max-height="400"
          v-loading="loading"
          :pagination="false"
          class="prodinfo--table"
          :customDefault="{
            height: '400px',
            text: `${
              order.supplierId ? $t('storage::in-stock::sku_select') : $t('storage::in-stock::supplier_select')
            }`,
          }"
        >
          <template #opt="{ row }">
            <el-button type="text" @click="toDetele(row)" style="color: #e62c11">
              {{ $t('system::function::delete') }}
            </el-button>
          </template>
          <template #skuId="{ row }">
            <span>{{ row.skuId }}{{ row.skuProperty ? '-' + row.skuProperty : '' }}</span>
          </template>
          <template #spuName="{ row }">
            <div class="prodinfo--table__imgTd">
              <el-popover placement="top-start" trigger="hover">
                <ZImg :src="row.img" style="width: 250px; height: 250px"></ZImg>
                <ZImg :src="row.img" style="width: 50px; height: 50px; margin-right: 10px" slot="reference"></ZImg>
              </el-popover>
              <div>
                <div>{{ row.title }}</div>
                <div>{{ row.categoryName }}</div>
              </div>
            </div>
          </template>
          <template #qty="{ row, $index }">
            <el-form-item
              label=""
              label-width="0"
              style="margin-bottom: 20px"
              :prop="'detailList.' + $index + '.qty'"
              :rules="{ validator: checkQuantity, prodObj: row, trigger: 'blur' }"
            >
              <el-input style="width: 150px" size="small" v-model.trim="row.qty"></el-input>
            </el-form-item>
          </template>
          <template #totalPrice="{ row, $index }">
            <el-form-item
              label=""
              label-width="0"
              style="margin-bottom: 20px"
              :prop="'detailList.' + $index + '.totalPrice'"
              :rules="{ validator: checkPrice, prodObj: row, trigger: 'blur' }"
            >
              <el-input style="width: 150px" size="small" v-model.trim="row.totalPrice"></el-input>
            </el-form-item>
          </template>
        </z-table>
      </el-form>
      <footer-fixed>
        <el-button @click="$router.go(-1)">
          {{ $t('storage::in-stock::cancel') }}
        </el-button>
        <el-button type="primary" @click="sumbit('saveAndCheck')">
          {{ $t('storage::in-stock::save_audit') }}
        </el-button>
        <el-button type="primary" @click="sumbit('save')">
          {{ $t('storage::in-stock::save') }}
        </el-button>
      </footer-fixed>
    </el-card>
    <sku-dialog
      v-model="isShowAddSku"
      :skuList="order.detailList"
      :supplier="order.supplierId"
      @addSku="addSku"
    ></sku-dialog>
    <uploadDialog v-model="isImportSku" :type="'in'" :supplier="order.supplierId" @addSku="importSku"></uploadDialog>
  </div>
</template>

<script>
import moment from 'moment'
import { getDicByCode } from '@/server/common'
import { getSupplierList } from '@/server/product'
import { addStockOrder, addAndCheckStockOrder, getStockOrderDetail } from '@/server/stock'
import { IN_STORAGE_ORDER_COLUMNS } from './config'
import skuDialog from '../components/skuDialog'
import uploadDialog from '../components/upload'
export default {
  components: { skuDialog, uploadDialog },
  data() {
    return {
      order: {
        supplierId: '',
        sourceNoType: '',
        sourceNo: '',
        fulfillmentNo: '',
        operTime: '',
        type: 1,
        thirdPartyNo: '',
        stockType: '',
        remark: '',
        detailList: [],
      },
      currentSupplier: '',
      rules: {
        stockType: [{ required: true, message: this.$t('storage::in-stock::in_type_select'), trigger: 'change' }],
        supplierId: [
          { required: true, message: this.$t('storage::in-stock::supplier_select_holder'), trigger: 'change' },
        ],
        operTime: [{ required: true, message: this.$t('storage::in-stock::instock_date_select'), trigger: 'change' }],
      },
      tableColumns: IN_STORAGE_ORDER_COLUMNS,
      tableData: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000
        },
      },
      searchValue: '',
      menuList: [],
      supplierList: [],
      loading: false,
      isShowAddSku: false,
      isImportSku: false,
      skuList: [],
      uploadUrl: `${process.env.VUE_APP_BASEURL}/ocean/api/v1/product/stock/import`,
    }
  },
  computed: {
    detailList() {
      return this.order.detailList.filter(el => String(el.skuId).includes(this.searchValue))
    },
  },
  mounted() {
    this.getDicByCode()
    this.getSupplier()
    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id)
    }
  },
  methods: {
    checkQuantity(rule, value, callback) {
      if (value === '' || value === null) {
        callback(new Error(this.$t('storage::in-stock::请输入数量')))
      } else if (!/^([1-9]\d*)$/.test(Number(value))) {
        callback(new Error(this.$t('storage::in-stock::请输入正确数量')))
      } else {
        callback()
      }
    },
    checkPrice(rule, value, callback) {
      if (value === '' || value === null) {
        callback(new Error(this.$t('storage::in-stock::请输入金额')))
      } else if (!/^(\.*)(\d+)(\.?)(\d{0,2}).*$/g.test(Number(value))) {
        callback(new Error(this.$t('storage::in-stock::请输入正确金额')))
      } else {
        callback()
      }
    },
    showAddSku() {
      this.isShowAddSku = true
    },
    addSku(list) {
      let tmpList = [...list]
      for (let i = 0; i < this.order.detailList.length; i++) {
        let item = this.order.detailList[i]
        let flag = false
        for (let j = 0; j < tmpList.length; j++) {
          if (item.skuId === tmpList[j].skuId) {
            flag = true
            tmpList.splice(j, 1)
            break
          }
        }
        if (!flag) {
          this.order.detailList.splice(i, 1)
          i--
        }
      }
      this.order.detailList = [...this.order.detailList, ...tmpList]
    },
    changeSupplier(val) {
      if (!this.order.detailList.length) {
        this.currentSupplier = val
        return
      }
      this.$confirm(
        this.$t('storage::in-stock::sku_clear_tips'),
        this.$t('storage::in-stock::change_supplier_tips') + '?',
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
        }
      )
        .then(() => {
          this.currentSupplier = val
          this.$set(this.order, 'detailList', [])
        })
        .catch(() => {
          this.$set(this.order, 'supplierId', this.currentSupplier)
        })
    },
    async getDetail(id) {
      this.loading = true
      const { data } = await getStockOrderDetail(id)
      if (data.code === this.$code) {
        this.order = data.data
        this.currentSupplier = data.data.supplierId
      }
      this.loading = false
    },
    async getSupplier() {
      const { data } = await getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 10000,
      })
      this.supplierList = data.data.items.map(item => {
        return { label: item.name, value: item.id }
      })
    },
    async getDicByCode() {
      const { data } = await getDicByCode(6)
      if (data.code === this.$code) {
        this.menuList = data.data.map(item => {
          return { label: this.$t(`system::inStock::type::${item.name}`), value: item.id }
        })
      }
    },
    toDetele(row) {
      this.order.detailList = this.order.detailList.filter(el => row.skuId != el.skuId)
    },
    sumbit(type) {
      if (!this.order.detailList.length) {
        this.$message.error(this.$t('storage::in-stock::请添加SKU'))
        return
      }
      this.$refs.order.validate(valid => {
        if (valid) {
          this.$refs.request.validate(valid => {
            if (valid) {
              if (type === 'save') {
                this.save()
              } else if (type === 'saveAndCheck') {
                this.saveAndCheck()
              }
            }
          })
        }
      })
    },
    async save() {
      const { data } = await addStockOrder({
        ...this.order,
        operTime: moment(this.order.operTime).format('YYYY-MM-DD'),
      })
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.$router.go(-1)
      }
    },
    async saveAndCheck() {
      const { data } = await addAndCheckStockOrder({
        ...this.order,
        operTime: moment(this.order.operTime).format('YYYY-MM-DD'),
      })
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.$router.go(-1)
      }
    },
    importSku(list) {
      this.order.detailList = [
        ...this.order.detailList,
        ...list.filter(el => !this.order.detailList.some(item => el.skuId === item.skuId)),
      ]
    },
  },
}
</script>

<style scoped lang="scss">
/deep/.el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
.card-title {
  font-weight: bold;
  font-size: 16px;
}
::v-deep.input-with-select .el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.prodinfo--table {
  &__imgTd {
    display: flex;
    align-items: center;
    padding: 10px 0;
    img {
      width: 50px;
      height: 50px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}
.stock-form {
  .input-item {
    width: 100%;
  }
  .el-input-number {
    width: 100%;
  }
}
/deep/.el-input-group__append {
  padding: 0 12px;
  background: #0560fd !important;
  color: #fff !important;
  border: 1px solid #0560fd;
}
</style>
